import { useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { Printer, Download } from "lucide-react";
import { Button } from "./ui/button";
import { PageHeader } from "./common";
import { SizeToggle, ThermalPageStyle } from "./DocSheet";
import { downloadFile, formatApiError, TZ } from "../lib/api";

export function DocToolbar({ title, pdfPath, filename, allowThermal = true, thermal, setThermal, extra }) {
  const download = async () => {
    try {
      await downloadFile(pdfPath, { size: thermal ? "80mm" : "a4", tz: TZ }, filename);
      toast.success("PDF downloaded");
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };
  return (
    <div className="no-print">
      {thermal && <ThermalPageStyle />}
      <PageHeader title={title} actions={
        <>
          {allowThermal && <SizeToggle thermal={thermal} setThermal={setThermal} />}
          {extra}
          <Button variant="outline" className="border-slate-700" onClick={() => window.print()} data-testid="doc-print-button"><Printer className="h-4 w-4" /> Print</Button>
          <Button className="bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold" onClick={download} data-testid="doc-download-pdf-button"><Download className="h-4 w-4" /> PDF</Button>
        </>
      } />
    </div>
  );
}

export function useDocParams() {
  const { id } = useParams();
  const [thermal, setThermal] = useState(false);
  return { id, thermal, setThermal };
}
